import api from '@/shared/api';
import type { VisibleDirectoryTree } from '../model/visible-tree.types';

export async function getFolderTree(): Promise<VisibleDirectoryTree> {
  const response = await api.get<{ data?: Partial<VisibleDirectoryTree> | null }>(
    '/folders/tree'
  );
  const data = response.data.data;
  return {
    modules: data?.modules ?? [],
    fixedFolders: data?.fixedFolders ?? [],
  };
}
